import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchExistingUtilityAccountsQuery,
  Flex_FetchExistingUtilityAccountsQueryVariables,
} from '~/typings/graphql';
import { FETCH_EXISTING_UTILITY_ACCOUNTS } from './fetch-existing-utility-accounts.queries';

type Utility = {
  id: number;
  displayName: string;
};

export type UtilityAccount = {
  id: number;
  accountNumber?: string | null | undefined;
  displayServiceAddress: string;
  hasInValidScraperDetails?: boolean;
  hasVnmProduct: boolean;
  utility: Utility;
};

export interface FetchExistingUtilityAccountsParams {
  userId: number;
}

export interface FetchExistingUtilityAccountsResponse {
  utilityAccounts: UtilityAccount[];
}

export const fetchExistingUtilityAccounts = async (
  params: FetchExistingUtilityAccountsParams,
): Promise<FetchExistingUtilityAccountsResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchExistingUtilityAccountsQuery,
    Flex_FetchExistingUtilityAccountsQueryVariables
  >({
    query: FETCH_EXISTING_UTILITY_ACCOUNTS,
    variables: { userId: params.userId },
  });

  const { accounts } = data.user;
  const utilityAccounts = accounts.map(a => a.utilityAccounts).flat();
  return { utilityAccounts };
};
